import { ApplicationDateOfBirthScreen } from "@/interactors/ApplicationDateOfBirthScreen";

export default function DateOfBirth() {
  return <ApplicationDateOfBirthScreen />;
}
